import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

const GetStyles = (count: number | undefined) =>
  useStyles(({theme, mediaOnly, deviceSize}) => {
    return {
      textContainer: {
        ...theme.fonts.h1,
        paddingBottom: 1,
      },
      textContainerMobile: {
        ...theme.fonts.h6,
        paddingBottom: 20,
        marginHorizontal: 20,
        textAlign: 'center',
      },
      icon: {
        height: 12,
        width: 12,
        color: theme.color.primaryColor,
      },
      notificationContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingVertical: 13,
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderColor: theme.color.borderColor,
        paddingLeft: deviceSize === DeviceSize.desktop ? 15 : 2,
        paddingRight: deviceSize === DeviceSize.desktop ? 0 : 23,
      },
      mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: deviceSize === DeviceSize.desktop ? -14 : 28,
        ...mediaOnly(DeviceSize.desktop, {paddingBottom: !count || count <= 3 ? 60 : 6}, {paddingBottom: 0}),
      },
      buttonMore: {
        marginTop: 30,
        marginBottom: 20,
        marginRight: 0,
        paddingHorizontal: 20,
        minWidth: 180,
        width: 'auto',
        alignSelf: 'flex-end',
      },
      linkMoreContainer: {
        width: 'auto',
        justifyContent: 'center',
        alignSelf: 'flex-end',
        ...mediaOnly(DeviceSize.desktop, {height: 54}, {height: 56}),
      },
      linkMore: {
        alignItems: 'center',
        flexDirection: 'row',
      },
      pressButtonText: mediaOnly(
        DeviceSize.desktop,
        {},
        {
          color: theme.color.primaryColor,
          fontSize: 16,
          lineHeight: 24,
        },
      ),
      colBodyMessageText: {
        ...theme.fonts.h5Light,
        color: theme.color.textColor,
      },
      colBodyMessageTextNotRead: {
        ...theme.fonts.h5,
        color: theme.color.textColor,
      },
      colBodyText: {
        ...theme.fonts.h5Light,
        color: theme.color.labelText,
      },
      colBodyTextNotRead: {
        ...theme.fonts.h5,
        color: theme.color.textColor,
      },
      colStatus: {
        flexBasis: 92,
        alignItems: 'center',
        justifyContent: 'center',
      },
      colText: {
        marginRight: 20,
        flexGrow: 1,
        flexShrink: 1,
      },
      colDateHeadText: theme.fonts.label,
      colDate: {
        flexBasis: 152,
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 20,
        paddingTop: 6,
        paddingBottom: 6,
      },
      colTimeHeadText: theme.fonts.label,
      colTime: {
        flexBasis: 160,
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 6,
        paddingBottom: 6,
      },
      linkMoreText: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h6Light, theme.fonts.body),
        color: theme.color.primaryColor,
        marginRight: 4,
      },
    };
  });

export type Styles = ReturnType<typeof GetStyles>;

export default GetStyles;
